<template>
  <div>
    <WidgetsDropdown />

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader> Recently {{ rows }} Entries </CCardHeader>

          <CCardBody>
            <CButton @click="csv_export" color="primary" class="mb-2"
              >CSV Export</CButton
            >
            <div class="overflow-auto">
              <b-table
                id="my-table"
                :items="items"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                small
              >
                >
                <!-- A custom formatted column -->
                <template #cell(uname)="data">
                  <td>
                    <CIcon
                      :name="
                        'cif-' +
                        (data.item.user_countryNameCode
                          ? data.item.user_countryNameCode.toLowerCase()
                          : '')
                      "
                      width="40"
                    />
                    {{ data.item.uname }}
                  </td>
                </template>
                <template #cell(attachAIDs)="data">
                  <td
                    style="cursor: pointer"
                    @click="() => attachview(data.item)"
                  >
                    <CIcon
                      name="cil-paperclip"
                      width="20"
                      v-show="data.item.attachAIDs != ''"
                    />
                  </td>
                </template>
              </b-table>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                style="float: right"
              ></b-pagination>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      :show.sync="visibleAttachView"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Attached Files"
      color="dark"
    >
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="200"
        img-height="200"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Text slides with image -->
        <b-carousel-slide
          :img-src="path"
          v-for="path in attachPaths"
          :key="path"
        ></b-carousel-slide>
      </b-carousel>
      <template #header>
        <h6 class="modal-title">Attached Files</h6>
        <CButtonClose @click="visibleAttachView = false" class="text-white" />
      </template>
      <template #footer>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import firebase from "firebase";
import { timeConverter, from_0, to_24 } from "../common-functions.js";
import * as Const from "../const.js";
export default {
  name: "Dashboard",
  components: {
    WidgetsDropdown,
  },
  data() {
    return {
      visibleAttachView: false,
      attachPaths: [],
      slide: 0,
      sliding: null,
      totalRows: 100,
      currentPage: 1,
      perPage: Const.perPage,
      items: [],
      fields: [
        {
          key: "entryDate",
          label: "Entry Date",
          _classes: "font-weight-bold",
          sortable: true,
        },

        { key: "uname", label: "User", sortable: true },
        { key: "bname", label: "Business", sortable: true },
        { key: "bcardname", label: "Business Card Name", sortable: true },
        { key: "btype", label: "Business Type", sortable: true },
        { key: "bmobile", label: "Business Mobile", sortable: true },
        { key: "cname", label: "Customer", sortable: true },
        {
          key: "customerPhoneNumber",
          label: "Customer Phone",
          sortable: true,
        },
        { key: "customerType", label: "Customer Type", sortable: true },
        {
          key: "amountGave",
          label: "Gave",
          _classes: "font-weight-bold",
          sortable: true,
        },
        {
          key: "amountGot",
          label: "Got",
          _classes: "font-weight-bold",
          sortable: true,
        },
        { key: "detail", label: "Detail", sortable: true },
        { key: "attachPaths", label: "Attach" },

        { key: "createdAt", label: "Created At", sortable: true },
        { key: "updatedAt", label: "updated At", sortable: true },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  created: function () {
    
    this.loadCountries();

    this.loaddata();
  },
  methods: {
    loadCountries() {
      var db = firebase.firestore();
      let countries = [{ value: "", label: "All" }];

      this.$store.commit("set", ["loading_country", true]);
      console.log("here");
      db.collection("user_countries")
        //.orderBy("countryNameCode")
        .orderBy("countryCode")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            countries.push({
              label:
                Const.regionNames.of(doc.data().countryNameCode) +
                " (+" +
                doc.data().countryCode +
                ")", // "United States"doc.data().countryNameCode,
              value: doc.data().countryNameCode,
            });
          });
          this.$store.commit("set", ["loading_country", false]);
          this.$store.commit("set", ["countries", countries]);
          console.log("here - end");
        });
    },
    loaddata() {
      console.log("loaddata");
      var db = firebase.firestore();
      console.log("currentPage", this.currentPage);
      this.$store.commit("set", ["loading1", true]);
      db.collection("entry")
        .where("isDeleted", "==", false)
        .orderBy("entryDate", "desc")
        .limit(this.totalRows)
        .get()
        .then((querySnapshot) => {
          this.items = [];

          querySnapshot.forEach((doc) => {
            var entry = {
              entryDate: timeConverter(doc.data().entryDate.seconds),
              eid: doc.id,
              uname: doc.data().userPhoneNumber,
              user_countryNameCode: doc.data().userCountryNameCode,
              uid: doc.data().uid,
              cid: doc.data().cid,
              cname: doc.data().customerName,
              bid: doc.data().bid,
              bname: doc.data().businessName,
              bcardname: doc.data().businessCardName,
              btype: doc.data().businessCardType,
              bmobile: doc.data().businessCardMobile,
              attachAIDs:
                (doc.data().photos && doc.data().photos.length > 0) ||
                (doc.data().attachAIDs && doc.data().attachAIDs.length > 0)
                  ? doc.id
                  : "",

              detail: doc.data().detail,

              customerPhoneNumber: doc.data().customerPhoneNumber,
              customerType:
                doc.data().customerType == 1 ? "Supplier" : "Customer",

              amountGave: doc.data().amountGave,
              amountGot: doc.data().amountGot,
              amountSumGave: doc.data().amountSumGave,
              amountSumGot: doc.data().amountSumGot,
              createdAt: timeConverter(doc.data().createdAt.seconds),
              updatedAt: timeConverter(doc.data().updatedAt.seconds),
              customerCount: doc.data().customerCount,
            };

            this.items.push(entry);

            //this.setNames(db, entry);
          });
          //this.items = JSON.parse(JSON.stringify(this.data));
          this.$store.commit("set", ["loading1", false]);
        });
    },
    // pageChange(val) {
    //   this.$router.push({ query: { page: val } });
    // },

    // setNames(db, entry) {
    //   var name = "";
    //   db.collection("users")
    //     .doc(entry.uid)
    //     .get()
    //     .then((user) => {
    //       if (user.exists) {
    //         entry.uname = user.data().phoneNumber;
    //       } else {
    //         console.log("No such document!");
    //       }
    //       entry.user_countryNameCode = user.data().countryNameCode;
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document 1:", error);
    //     });

    //   db.collection("business")
    //     .doc(entry.bid)
    //     .get()
    //     .then((business) => {
    //       if (business.exists) {
    //         name = business.data().name;
    //       } else {
    //         console.log("No such document!");
    //       }
    //       entry.bname = name;
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document:", error);
    //       return "E-bname";
    //     });
    //   db.collection("business_card")
    //     .doc(entry.bid)
    //     .get()
    //     .then((business_card) => {
    //       if (business_card.exists) {
    //         entry.bcardname = business_card.data().name;
    //         entry.btype = business_card.data().type;
    //         entry.bmobile = business_card.data().mobile;
    //       } else {
    //         console.log("No such document! bid = " + entry.bid);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document:", error);
    //       return "E-bname";
    //     });
    //   db.collection("customer")
    //     .doc(entry.cid)
    //     .get()
    //     .then((doc) => {
    //       if (doc.exists) {
    //         name = doc.data().name;
    //       } else {
    //         console.log("No such document!");
    //       }
    //       entry.cname = name;
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document:", error);
    //       return "E-cname";
    //     });

    //   //console.log("attach", entry.attachAIDs);
    //   //console.log("uid", entry.uid);
    //   db.collection("attach")
    //     .where("eid", "==", entry.eid)
    //     .where("isDeleted", "==", false)
    //     .get()
    //     .then((querySnapshot) => {
    //       // console.log(querySnapshot);
    //       entry.attachPaths = [];
    //       querySnapshot.forEach((doc) => {
    //         if (doc.exists) {
    //           entry.attachPaths.push(doc.data().storeURL);
    //         } else {
    //           console.log("No such Business document!");
    //         }
    //       });
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document 3:", error);
    //     });
    // },
    attachview(item) {
      console.log("-- attach view here--", item);
      var db = firebase.firestore();

      db.collection("attach")
        .where("uid", "==", item.uid)
        .where("bid", "==", item.bid)
        .where("cid", "==", item.cid)
        .where("eid", "==", item.eid)
        .get()
        .then((querySnapshot) => {
          // console.log(querySnapshot);
          this.attachPaths = [];
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              this.attachPaths.push(doc.data().storeURL);
            } else {
              console.log("No such Business document!");
            }
          });
          this.visibleAttachView = true;
        })
        .catch((error) => {
          console.log("Error getting document 3:", error);
        });
    },
    csv_export() {
      let csvContent = "";
      var header = [
        "Entry date",
        "User",
        "Business Name",
        "Business Card Name",
        "Business Type",
        "Business Mobile",

        "Customer",
        "Gave",
        "Got",
        "Detail",
        "created_at",
        "updated_at",
      ];
      var universalBOM = "\uFEFF";
      let row = header.join(",");
      csvContent += row + "\r\n";

      this.items.forEach(function (row) {
        var row_str = "";
        row_str += '"' + row.entryDate + '",';
        row_str += '"' + row.uname + ' ",';
        row_str += '"' + row.bname + '",';
        row_str += '"' + row.bcardname + '",';
        row_str += '"' + row.btype + '",';
        row_str += '"' + row.bmobile + '",';
        row_str += '"' + row.cname + '",';
        row_str += '"' + row.amountGave + '",';
        row_str += '"' + row.amountGot + '",';
        row_str += '"' + row.detail + '",';
        row_str += '"' + row.createdAt + '",';
        row_str += '"' + row.updatedAt + '",';

        csvContent += row_str + "\r\n";
      });
      var universalBOM = "\uFEFF";
      var a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "data:text/csv; charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      a.setAttribute("download", "example.csv");
      window.document.body.appendChild(a);
      a.click();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>
